export default "__VITE_ASSET__DbbBwycj__"